import {createSelector} from 'reselect';
import differenceInDays from 'date-fns/difference_in_days';
import {getTripData} from './store';

// Returns number of nights between arrive/depart dates
const getTripNights = createSelector(
    [getTripData],
    (tripData) => {
        const {
            arriveDateText,
            departDateText
        } = tripData;

        return differenceInDays(departDateText, arriveDateText) || 0;
    }
);

export {
    getTripNights
};
